import { render, staticRenderFns } from "./BookmarkProductModalButton.vue?vue&type=template&id=29a7f99b&"
import script from "./BookmarkProductModalButton.vue?vue&type=script&lang=js&"
export * from "./BookmarkProductModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
